module.exports = __webpack_public_path__ + "static/media/brinquedo2.51d42e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brinquedo2.jpg
// module id = 58
// module chunks = 0